import React from 'react';

import { useParams } from 'react-router-dom';
import FormContents from 'components/atoms/Form/FormContents';
import PaidHolidayPatternInputAddForm from './PaidHolidayPatternInputAddForm';
import { divide } from 'lodash';

const PaidHolidayPatternAddForm: React.FC = () => {
  const {
    paidHolidayPatternId,
  } = useParams();

  return (
    <div>
      <PaidHolidayPatternInputAddForm paidHolidayPatternId={paidHolidayPatternId || ''} />
    </div>
  );
};

export default PaidHolidayPatternAddForm;
